import Vue from "vue";
import ScrollLoader from 'vue-scroll-loader';

Vue.use(ScrollLoader);
